"use client";
/*
 * Documentation:
 * Accordion — https://app.subframe.com/4f62853ee923/library?component=Accordion_d2e81e20-863a-4027-826a-991d8910efd9
 * DC_Text_Toggle — https://app.subframe.com/4f62853ee923/library?component=DC_Text_Toggle_e1d5091b-0ea3-4240-8029-26e2a3c31ee4
 */

import React from "react";
import * as SubframeUtils from "../utils";
import { Accordion } from "./Accordion";

interface Dc_Text_ToggleRootProps extends React.HTMLAttributes<HTMLDivElement> {
  triggerText?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Dc_Text_ToggleRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Text_ToggleRootProps
>(function Dc_Text_ToggleRoot(
  { triggerText, children, className, ...otherProps }: Dc_Text_ToggleRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex w-full flex-col items-start gap-4 rounded-md bg-neutral-50 px-3 py-2",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <Accordion
        trigger={
          <div className="flex w-full items-center justify-between">
            {triggerText ? (
              <span className="grow shrink-0 basis-0 text-body-bold font-body-bold text-default-font">
                {triggerText}
              </span>
            ) : null}
            <Accordion.Chevron />
          </div>
        }
      >
        <div className="flex w-full grow shrink-0 basis-0 flex-col items-start gap-2">
          {children ? (
            <div className="flex flex-col items-start gap-2 pt-6">
              {children}
            </div>
          ) : null}
        </div>
      </Accordion>
    </div>
  );
});

export const Dc_Text_Toggle = Dc_Text_ToggleRoot;
